// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".authHeader_PpOBN{background:var(--cp-primary_main)}.authHeaderLogo_JlEJI{margin:0;padding:1.2rem 1.6rem}.authHeaderLogo_JlEJI img{height:100%}@media only screen and (min-width:768px){.authHeaderLogo_JlEJI{margin:0 0 .7rem;padding:1.5rem}}@media only screen and (min-width:1264px){.authHeaderLogo_JlEJI{padding:0 0 2.5rem}}@media only screen and (min-width:768px){.authHeader_PpOBN{padding:3.1rem 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authHeader": "authHeader_PpOBN",
	"authHeaderLogo": "authHeaderLogo_JlEJI"
};
module.exports = ___CSS_LOADER_EXPORT___;
